export default __webpack_public_path__ + "static/media/logo138x75black.e9124a95.png";